<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          p 新增藥物儲存
            span.icon-right(@click="$emit('cancelForm')") X
          div.form-group
            div.search-dynamic
              div.input-group
                div.input-group-prepend
                  span.input-group-text 選擇位置
                select.form-control(v-model="deviceId" @change="setCurrentDevice")
                  option(v-for="device, num in devices" :value="num") {{device.series}}
          div.form-group
            div.search-dynamic
              div.input-group
                div.input-group-prepend
                  span.input-group-text 選擇藥物
                input.form-control(v-model="searchDrug")
              div.input-options-wrap(v-show="medicines.length !== 0")
                div.input-option(v-for="med, num in medicines" @click="setMedicine(num)") {{med.code}} - {{med.CGMH_number}} - {{ med.generic_name }}
          div.form-group
            div.row
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 儲存數量
                input.form-control(type="number" v-model="stock" min=0)
              div.input-group.col-6
                div.input-group-prepend
                  span.input-group-text 最大存量
                input.form-control(type="number" v-model="maxStock" min=0)
          //- div.form-group
          //-   div.row
          //-     div.input-group.col-6
          //-       span.input-group-addon 使用期限
          //-       input.form-control(type="date" v-model="date")
          //-     div.input-group.col-6
          //-       span.input-group-addon 批號
          //-       input.form-control(v-model="batch" placeholder="選填")
          div.form-check
            label.form-check-label
              input.form-check-input(v-model="inventoried" type="checkbox" name="defaultLogin" value="password") 
              span 盤點與否
          button.btn.btn-primary(@click="createDrugStorage" :disabled="formComplete === false") 新增
</template>

<script>

import moment from 'moment';

export default {
  name: 'CreateDrugStorageForm',
  props: [
    'devices',
  ],
  data() {
    return {
      currentDevice: {},
      currentMedicine: {},
      searchDrug: '',
      medicines: [],
      deviceId: null,
      stock: 0,
      maxStock: 0,
      inventoried: false,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    formComplete() {
      if (Object.keys(this.currentDevice).length === 0) return false;
      if (Object.keys(this.currentMedicine).length === 0) return false;
      return true;
    },
  },
  methods: {
    setCurrentDevice() {
      this.currentDevice = this.devices[this.deviceId];
    },
    setMedicine(index) {
      this.currentMedicine = this.medicines[index];
      this.searchDrug = this.currentMedicine.generic_name;
      this.medicines = [];
    },
    async createDrugStorage() {
      this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          med_id: this.currentMedicine.id,
        },
      })
      .then((res) => {
        if (res.data.results.length === 0) {
          if (parseInt(this.maxStock, 10) >= parseInt(this.stock, 10)) {
            this.instance.post('/api/drug-storage/', {
              device: this.currentDevice.id,
              medication: this.currentMedicine.id,
              stock: this.stock,
              max_stock: this.maxStock,
              expired_date: moment().format('YYYY-MM-DD'),
              patch_number: null,
              inventoried_in_tag_system: this.inventoried,
              number1: this.stock,
              type: 'ADMIN_CREATE',
            })
            .then((res) => {
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '新增成功',
              });
              this.$parent.$refs.vuetable.refresh();
              this.$emit('cancelForm');
              this.$parent.getTagSystem()
              .then(() => {
                this.$parent.setCurrentTag();
                this.$parent.setCurrentNet();
              });
            })
            .catch((err) => {
              console.log(err.response);
              this.$store.commit('SET_MESSAGE', {
                type: 'error',
                context: '新增失敗',
              });
            });
          } else {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '最大庫存量不可小於庫存量',
            });
          }
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '此藥物已新增於系統中',
          });
        }
      });
    },
  },
  watch: {
    searchDrug(val) {
      if (val.length >= 3 && this.searchDrug !== this.currentMedicine.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val,
          },
        })
        .then((res) => {
          this.medicines = res.data.results;
        });
      } else {
        this.medicines = [];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CreateDrugStorageForm.vue?1764276a